import './App.css';
import HomePage from './HomePage';
import { Analytics } from "@vercel/analytics/react";

function App() {
  return (
    <>
      <HomePage />
      <Analytics />
    </>
  );
}

export default App;
